import styled from 'styled-components';

import { Image as Img } from '@xing-com/image';

const Container = styled.div`
  position: relative;
  line-height: 0;
`;

const Image = styled(Img)`
  width: 100%;
`;

export const Styled = {
  Container,
  Image,
};
